module.exports = __webpack_public_path__ + "img/nav.2348bf38.png";